import { Checkbox, FormControlLabel } from '@mui/material'
import { CONTROLS } from '~/components/Charts/chrome/chartChrome'
import type { PanelBaseMode } from '~/state/usePanelBaseState'

/** V7: extracted from GranularityControls (D3 — lives in the Comparison card).
 *  Visibility stays the scaffold's shouldShowPanelBase computation, UNCHANGED. */
export function PanelBaseCheckbox({
  value,
  onChange,
}: {
  value: PanelBaseMode
  onChange: (m: PanelBaseMode) => void
}) {
  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={value === 'prev'}
          onChange={(e) => onChange(e.target.checked ? 'prev' : 'off')}
        />
      }
      label={CONTROLS.previousPeriodBaseline}
    />
  )
}
